import { formatDate } from "../../utils/date";
import { Chip } from "@mui/material";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { ActionIconButton } from "../../components/datatable/DataGridActions";

const columnsData = [
  {
    field: "name",
    headerName: "Kid Name",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "full_name",
    headerName: "Mentor Name",
    minWidth: 120,
    flex: 1,
    renderCell: (params) => {
      return (
        <>{params.row.is_anonymous ? "Anonymous" : params.row.full_name}</>
      );
    },
  },
  {
    field: "mentor_date",
    headerName: "Mentor Date",
    flex: 1,
    minWidth: 120,
    renderCell: (params) => {
      return <div>{formatDate(params.row.mentor_date)}</div>;
    },
  },
  {
    field: "expire_date",
    headerName: "Expire Date",
    flex: 1,
    minWidth: 120,
    renderCell: (params) => {
      return <div>{formatDate(params.row.expire_date)}</div>;
    },
  },
  {
    field: "is_read",
    headerName: "Status",
    minWidth: 140,
    flex: 1,
    renderCell: (params) => {
      return (
        <div>
          <Chip
            label={params.row.is_read ? "Read" : "Not yet Read"}
            variant="outlined"
            color={params.row.is_read ? "success" : "error"}
          />
        </div>
      );
    },
  },
];

let actionHeader = (handleDelete, setOpen, setSelectedRow) => {
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      minWidth: 72,
      maxWidth: 90,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="cellAction cellAction--icons">
            <ActionIconButton
              title="Delete notification"
              onClick={() => handleDelete(params.row.id)}
              color="error"
            >
              <DeleteOutlineRoundedIcon fontSize="small" />
            </ActionIconButton>
          </div>
        );
      },
    },
  ];
  return actionColumn;
};

const columnHeader = {
  columnsData,
  actionHeader,
};

export default columnHeader;
